import React from "react";

import "./styles.scss";

interface ButtonMobileProps {
  type?: "underline";
  text: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const ButtonMobile = ({ type, style, text, onClick }: ButtonMobileProps) => {
  return (
    <span
      onClick={onClick}
      style={style}
      className={`${type === "underline" ? "button-mobile-underline" : ""}`}>
      {text}
    </span>
  );
};

export default ButtonMobile;
